<template>
	<Datepicker
		:key="elKey"
		input-class="date_int"
		:typeable="true"
		:language="en"
		:value="value"
		format="MM-dd-yyyy"
		:highlighted="highlighted"
		@input="updateValue"
		@changedMonth="changedMonth"
		:disabled="disabled"
		:disabled-dates="disableDates"
	></Datepicker>
</template>

<script>
//import moment from 'moment';
import Datepicker from 'vuejs-datepicker';
import { en } from 'vuejs-datepicker/dist/locale';
// import '@/assets/css/layout.css';
import { toText } from '@/utils/date.js';

export default {
	props: ['value', 'disabled', 'disable_past', 'disable_future'],
	watch: {
		value: {
			handler() {
				if (this.value !== this.displayValue) {
					this.elKey++;

					this.$nextTick(() => {
						let date_picker_el = this.$el.querySelectorAll("input[type='text'], input[type='number']");
						date_picker_el.forEach(el => el.addEventListener('click', e => e.target.select()));
					});
				}
			},
		},
	},
	name: 'customDatePicker',
	data: function() {
		return {
			en: en,
			highlighted: {
				dates: [new Date()],
			},
			disableDates: {},
			displayValue: null,
			elKey: 0,
		};
	},
	components: {
		Datepicker,
	},
	methods: {
		updateValue: function(event) {
			this.$emit('input', this.valueFormat(event));
		},
		valueFormat(date) {
			if (date == null) return null;
			//console.log(date);
			//console.log(toText(date, '-'));

			date = toText(date, '-');
			this.displayValue = date;
			return date;
			// console.log(date);
			// var inputDate = new Date(date);
			// console.log(inputDate);
			// console.log(moment(inputDate).format('MM-DD-yyyy'));
			// return (
			// 	moment(inputDate)
			// 		//.tz(this.$session.get('time_zone'))
			// 		.format('MM-DD-yyyy')
			// );
		},
		changedMonth: function(event) {
			//console.log('changed...', event);
			var date;
			if (event.timestamp) date = event.timestamp;
			else date = event;
			//this.$emit('input', this.valueFormat(event));
			this.$emit('input', this.valueFormat(date));
		},
	},
	created() {
		//console.log(this.disable_past);
		//if (this.disable_past) this.disableDates = { to: daysAgo(-1) };
		if (this.disable_past) {
			var d = new Date();
			//d.setDate(d.getDate() - 1);
			this.disableDates = { to: d };
		} else if (this.disable_future) {
			var d2 = new Date();
			d2.setDate(d2.getDate() + 1);
			this.disableDates = { from: d2 };
		}

		//this.disableDates = { to: new Date(2022, 3, 5), from: new Date(2022, 3, 25) };
	},
};
</script>

<style>
.vdp-datepicker {
	display: inline-block;
}
</style>
